// extracted by mini-css-extract-plugin
export default {"container":"Documentation_container__PLAg8"};